import { render, staticRenderFns } from "./CustomFile.vue?vue&type=template&id=438ce90c&"
import script from "./CustomFile.vue?vue&type=script&lang=ts&"
export * from "./CustomFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports